import React, { useEffect, useState } from "react";
import { t } from "i18next";
import {
  faDollarSign,
  faCloudArrowDown,
} from "@fortawesome/pro-regular-svg-icons";
import { DocumentIcon } from '@heroicons/react/24/outline';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { Select } from "@/shared/components/organisms/Select";
import { Option } from "@/shared/components/molecules/OptionsSelect";
import { DateRangePicker } from "@/shared/components/atoms/DataRangePicker";
import DescriptionHeadings from "@/shared/components/atoms/DescriptionHeadings";
import KpiTableComponent from "@/shared/components/organisms/KpiTableComponent";
import {
  useSummaryQuery,
  useSummaryExportMutation,
} from "@/app/summary/summary.api";

import { parseDateUTC } from "@/shared/utils/formatedDate";
import {
  useGetAccessBranchQuery,
  useGetStatusClientsQuery,
} from "@/app/kpi/kpi.api";

// Type
import { Branch } from "@/app/branchs/branchs.type";
import { CatchmentRequest } from "@/app/catchment/catchment.types";

export const initialValues: CatchmentRequest = {
  search: "",
  branch_filter: null,
  sex_filter: null,
  campaign_filter: null,
  stages_filter: null,
  stages_users_filter: null,
  tag_marketing_filter: null,
  catchment_page: "campaigns",
};

export type SummaryProps = {
  branches: Branch[];
};

const CaptationFidelizationComponent: React.FC<SummaryProps> = ({branches}) => {
  const { data: statusClients } = useGetStatusClientsQuery({});
  const [branchSelected, setBranchSelected] = useState<Option>();
  const [optionsCurrencies, setOptionsCurrencies] = useState<Option[]>([]);
  const [currencySelected, setCurrencySelected] = useState<Option>();
  const [catchmentExport] = useSummaryExportMutation();

  const [formValues, setFormValues] = useState(initialValues);
  const summaryQuery = useSummaryQuery(formValues);

  const [headersVerticalKpiTable, setHeadersVerticalKpiTable] = useState<
    string[]
  >([]);
  const [headers2VerticalKpiTable, setHeaders2VerticalKpiTable] = useState<
    string[]
  >([]);
  const [branchesOptions, setBranchesOptions] = useState<
    { id: number; name: string }[]
  >([]);

  useEffect(() => {
    if (branches) {
      setBranchesOptions(
        branches.map((branch: Branch) => ({
          id: branch.id,
          name: branch.branch,
        }))
      );
    }
  }, [branches]);

  useEffect(() => {
    if (branchesOptions.length > 0 && !branchSelected) {
      setBranchSelected(branchesOptions[0]);
    }
    if (optionsCurrencies.length > 0 && !currencySelected) {
      setCurrencySelected(optionsCurrencies[0]);
    }
  }, [branchesOptions, optionsCurrencies, branchSelected, currencySelected]);

  /*
  const dataTable = {
    Manual : [30, 22, 16, 8, 14, '36.3%'],
  };
  */

  const [dataTable, setDataTable] = useState<any>({});

  useEffect(() => {
    console.log("summaryQuery", summaryQuery);
    if (summaryQuery.data) {

      console.log("summaryQuery.data.data_users", summaryQuery.data);

      setDataTable({
        "": [
          summaryQuery.data.data_users?.users ?? 0,
          summaryQuery.data.data_users?.users_active ?? 0,
          summaryQuery.data.data_users?.users_inactive ?? 0,
          summaryQuery.data.data_users?.users_last_month ?? 0,
          summaryQuery.data.data_users?.users_repeat ?? 0,
          summaryQuery.data.data_users?.users_rotation ?? "0%",
        ],
      });
    }
  }, [summaryQuery]);

  const dataTable2 = {
    'Recuperaciones (Bajas Antiguas)': [0, 0, 0, 0, '0%'],
    'Captación (Directo al Centro)': [0, 0, 0, 0, '0%'],
    'Captación (Meta)': [0, 0, 0, 0, '0%'],
    'Captación (Desde formulario web de nuevas cuotas)': [0, 0, 0, 0, '0%'],
    'Captación (Convenios de empresas)': [0, 0, 0, 0, '0%'],
    'TOTALES': [0, 0, 0, 0, '0%'],
  };

  const rowColors = [
    'bg-[#fc7cb4]',
    'bg-[#D7C2FF]',
    'bg-gray-100',
    'bg-gray-100',
    'bg-gray-100',
    'bg-gray-100',
  ];

  const rowColors2 = [
    'bg-[#D7C2FF]',
    'bg-[#D7C2FF]',
    'bg-[#D7C2FF]',
    'bg-[#D7C2FF]',
    'bg-[#D7C2FF]',
    'bg-[#D7C2FF]',
  ];

  useEffect(() => {
    const loadHeaders = () => {
      const headers = [
        'Socios actuales',
        'Socios al finalizar el mes anterior',
        'Altas',
        'Bajas',
        'Repiten',
        'Rotación',
      ];
      setHeadersVerticalKpiTable(headers);

      const headers2 = [
        'NUEVOS LEADS (ETAPA DE NEGOCIO: INTERESADOS)',
        'VISITAS (ETAPA DE NEGOCIO: VISITAS AL CENTRO)',
        'RATIO VISITAS/NUEVOS LEADS',
        'ALTAS (ETAPA DE NEGOCIO: GANADOS CONVERTIDO A USUARIO)',
        'RATIO ALTAS/VISITAS',
      ];
      setHeaders2VerticalKpiTable(headers2);
    };

    loadHeaders();
  }, []);

  useEffect(() => {
    if (statusClients && statusClients.currency) {
      const currencyArray = Object.values(statusClients.currency);
      const currencies: Option[] = currencyArray.map((currency: any) => ({
        id: currency,
        name: currency,
      }));

      setOptionsCurrencies(currencies);
    }
  }, [statusClients]);

  const { data: getAccessBranch } = useGetAccessBranchQuery({});

  useEffect(() => {
    if (getAccessBranch) {
      const dayChartArray: string[] = [];
      let userTotalBranch = 0;
      let userAverageBranch = 0;
      const accessData: any = [];

      getAccessBranch.map((accessItem: any) => {
        const date = accessItem["day"] + "/" + accessItem["month"];
        dayChartArray.push(`'${date}'`);
        userTotalBranch += accessItem["total"] ?? 0;
        userAverageBranch = accessItem["average"];
        accessData.push(accessItem["total"]);
      });

      // captionChart2(dayChartArray, accessData);
      // setUserTotalBranch(userTotalBranch);
      // setUserAverageBranch(userAverageBranch ?? 0);
    }
  }, [getAccessBranch]);

  const handleExport = async () => {
    try {
      const response = await catchmentExport({
        ...formValues,
      }).unwrap();

      // Crear un blob con el tipo de contenido correcto
      const blob = new Blob([response], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      // Crear un enlace temporal para descargar el archivo
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "summary.xlsx"); // Nombre del archivo
      document.body.appendChild(link);
      link.click();
      link.remove();

      // Liberar el objeto URL después de la descarga
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error exporting catchment:", error);
    }
  };

  return (
    <>
      <div className="p-4">
        <DescriptionHeadings
          title={t("user.views.summary")}
          description={t("user.views.summary_description")}
        />
        <div className="grid grid-cols-12 gap-4">
          <div className="p-4 mt-6 bg-white shadow rounded-lg col-span-12">
            <div className="mb-4">
              <h4 className="text-base font-semibold leading-6 text-gray-900  text-center">
                {t("user.views.main_title_summary")}
              </h4>
            </div>

            <div className="flex flex-wrap items-center justify-center gap-4 w-full">         
              <DateRangePicker
                label={`${t("kpi.views.Inicio")} - ${t("kpi.views.Final")}`}
                id="2"
                value={{
                  startDate: parseDateUTC(
                    new Date().toISOString().split("T")[0]
                  ),
                  endDate: parseDateUTC(
                    new Date().toISOString().split("T")[0]
                  ),
                }}
                onDateChange={(startDate: Date, endDate: Date) => {
                  // Se agrega la funcion para cuando cambie la fecha
                }}
              />
              <Select
                name=""
                options={optionsCurrencies}
                tittle={t("store.views.form.currency")}
                selected={currencySelected}
                setSelected={setCurrencySelected}
              />
              <Select
                name="branch"
                selected={branchSelected}
                setSelected={setBranchSelected}
                options={branchesOptions}
                tittle={t("user.views.branch")}
              />
              <div className="relative">
                <button
                  type="button"
                  className="text-gray-400 hover:text-gray-500 hidden md:block mt-6"
                >
                  <span className="sr-only">Export</span>
                  <FontAwesomeIcon
                    icon={faCloudArrowDown}
                    aria-hidden="true"
                    className="h-10 w-10"
                    onClick={handleExport}
                  />
                </button>
              </div>
            </div>

            <div className="text-center mb-4 flex flex-col md:flex-row justify-center items-center mt-5">
              <div className="mb-2 p-4 text-center w-full md:w-1/2">
                <div className="flex justify-center w-full">
                  <div className="max-h-full w-full">
                    <KpiTableComponent
                      dataTable={dataTable}
                      headers={[""]}
                      headersVertical={headersVerticalKpiTable}
                      rowColors={rowColors}
                      rowColorsData={rowColors}
                    />
                  </div>
                </div>
              </div>
              <div className="flex items-center hidden md:flex">
                <div className="border-l border-gray-200 h-80 mx-4"></div>
              </div>
              <div className="mb-2 p-4 text-center w-full md:w-1/2 items-center">
                <div className="flex justify-center items-center mt-4">
                  <div className="relative">
                    <DocumentIcon className="h-28 w-28 text-gray-500" />
                    <FontAwesomeIcon
                      icon={faDollarSign}
                      className="h-12 w-12 text-gray-500 absolute top-11 left-8"
                    />
                  </div>
                </div>
                <div className="flex flex-col md:flex-row justify-between items-center mt-4">
                  <div className="text-center w-full md:w-1/2 xl:w-1/3 p-4">
                    <p className="text-base font-semibold text-gray-700 mb-2">
                      {/* t("user.views.title1") */}
                      Facturación total
                    </p>
                    <div className="bg-gray-100 p-4 rounded w-full mx-auto">
                      <p className="text-2xl font-semibold text-[#68478d]">
                        {summaryQuery.data?.benefits?.data}
                      </p>
                    </div>
                  </div>
                  <div className="text-center w-full md:w-1/2 xl:w-1/3 p-4">
                    <p className="text-base font-semibold text-gray-700 mb-2">
                      {/*t("user.views.title2")*/}
                      Beneficios totales
                    </p>
                    <div className="bg-gray-100 p-4 rounded w-full mx-auto">
                      <p className="text-2xl font-semibold text-[#68478d]">
                        {summaryQuery.data?.income?.data?.total}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
          <div className="p-4 mt-6 bg-white shadow rounded-lg col-span-12 min-h-96">
            <div className="text-center mb-4 flex justify-center items-center w-full sm:w-11/12 mx-auto">
              <div className="max-h-full w-full">
                <KpiTableComponent
                  dataTable={dataTable2}
                  headers={[""]}
                  headersVertical={headers2VerticalKpiTable}
                  rowColors={rowColors2}
                />
              </div>
            </div>
          </div>


          <div className="p-4 mt-0 bg-white shadow rounded-lg col-span-12 text-center">
            <p className="text-base text-gray-400">
              Nota: Solo se muestran las campañas de captación que hayan registrado usuarios en algún momento.
            </p>
          </div>

        </div>
      </div>
    </>
  );
};

export default CaptationFidelizationComponent;
